/**
 * MemberStatusType Enum - Based on MemberStatusType.java
 * Origin of the member's current status: the coverage its status was taken from.
 */
export enum MemberStatusType {
  SUBSCRIPTION = 'SUBSCRIPTION',
  COURTESY = 'COURTESY',
  NONE = 'NONE',
}
